import { useField } from "formik";
import React from "react";
import { ItemSelect, Props as ItemSelectProps } from "../ItemSelect.js";

interface Props extends Omit<ItemSelectProps, "itemId" | "onChange"> {
  name: string;
}

export const ItemField = ({ name, ...props }: Props) => {
  const [{ value }, { error }, { setValue }] = useField<string | null>(name);
  return (
    <ItemSelect
      error={error}
      itemId={value}
      onChange={async item => {
        await setValue(item?.id ?? null);
      }}
      {...props}
    />
  );
};
